import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const MAYBELLINE_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  1: setDirectAnswerPreset(
    "Maybelline Cosmetics",
    "EYE CATEGORY - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Maybelline EYE category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].maybelline.eye_oos_before()
  ),
  2: setDirectAnswerPreset(
    "Maybelline Cosmetics",
    "FACE Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Maybelline FACE category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].maybelline.face_oos_before()
  ),
  3: setDirectAnswerPreset(
    "Maybelline Cosmetics",
    "Lip Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Maybelline Lip category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].maybelline.lip_oos_before()
  ),
  4: setDirectAnswerPreset(
    "Maybelline Cosmetics",
    /What is the total number of pieces of Maybelline .* you stocked today/i,
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].maybelline.total_stocked()
  ),
  5: setDependentAnswerPreset(
    "Maybelline Cosmetics",
    "MAYBELLINE EYE: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [1],
    beautyUtils.getAfterOOSCount
  ),
  6: setDependentAnswerPreset(
    "Maybelline Cosmetics",
    "Maybelline FACE: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [2],
    beautyUtils.getAfterOOSCount
  ),
  7: setDependentAnswerPreset(
    "Maybelline Cosmetics",
    "Maybelline LIP: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [3],
    beautyUtils.getAfterOOSCount
  ),
  8: setDependentAnswerPreset(
    "Maybelline Cosmetics",
    "MAYBELLINE EYE: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [5],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  9: setDependentAnswerPreset(
    "Maybelline Cosmetics",
    "Maybelline FACE: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [6],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  10: setDependentAnswerPreset(
    "Maybelline Cosmetics",
    "Maybelline LIP: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [7],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  11: setDependentAnswerPreset(
    "Maybelline Cosmetics",
    "Select why 0 Items needed a count correction",
    "text",
    [8, 9, 10],
    beautyUtils.getWhyZeroItemsNeededCountCorrection
  ),
  12: setDirectAnswerPreset(
    "Maybelline Cosmetics",
    "Are there shelf labels missing on the Maybelline Cosmetic POG",
    "radio",
    () => "No shelf labels are missing from the MNY POG"
  ),
  13: setDependentAnswerPreset(
    "Maybelline Cosmetics Count Corrections",
    "Did a Team Lead assist you during your service to correct any Maybelline Cosmetics EYE or FACE or Lip incorrect counts for out of stock items in the Inventory Audit",
    "radio",
    [8, 9, 10],
    beautyUtils.getDidATeamMemberAssistYouWithUpdatingOnHands
  ),
  14: setDependentAnswerPreset(
    undefined,
    "MAYBELLINE EYE: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [8],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  15: setDependentAnswerPreset(
    undefined,
    "Maybelline FACE: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [9],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  16: setDependentAnswerPreset(
    undefined,
    "Maybelline LIP: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [10],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
};
